import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useEffectiveMe } from '@/lib/effectiveMe';
import { canUseHaccpTemperature } from './haccpAccess';

export default function RequireHaccpTemperatureAccess({ children }) {
  const { loading } = useAuth();
  const me = useEffectiveMe();
  if (loading) return null;
  if (!me || !canUseHaccpTemperature(me)) {
    return <Navigate to="/access-denied" replace />;
  }
  return children;
}
